import React from 'react';

// Spec §13 PageHeader — eyebrow/title/subtitle left, optional action right.
const PageHeader = ({ eyebrow, title, subtitle, action, large = false, className = '' }) => {
  return (
    <div className={`flex flex-col sm:flex-row sm:items-center items-stretch justify-between gap-2 w-full text-left mb-6 ${className}`}>
      <div>
        {eyebrow && (
          <p
            className="text-accent font-medium font-mono mb-1"
            style={{ fontSize: '0.875rem' }}
          >
            {eyebrow}
          </p>
        )}
        <h1
          className="text-textPrimary font-semibold"
          style={{ fontSize: large ? '1.75rem' : '1.375rem' }}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-textSecondary mt-1" style={{ fontSize: '0.875rem', lineHeight: 1.5 }}>
            {subtitle}
          </p>
        )}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
};

export default PageHeader;
